<template src="./html/thank-you.html"></template>

<style lang="scss" src="./styles/main.scss"></style>

<i18n src="./i18n/i18n.json"></i18n> 

<script>
import Vue from 'vue';
import axios from 'axios';

import { content_ids } from './data/contentIds.js';
import { computedFunctions } from "./exports/computedFunctions.js";

export default {
  name: 'cookie-pass',
  data () {
    return {
      legal: {"content":{"rendered":""}},
      formdata: '',
      contentIds: content_ids
    }
  },
  mixins: [
    computedFunctions
  ],
  created() {
    
    let region = this.$route.params.lang || 'en';
    this.$i18n.locale = region;
    this.$i18n.fallbackLocale = 'en';

    const pageId = this.contentIds['legal'][this.$i18n.locale];

    axios.get(process.env.JSON_LOCATION)
    .then(response => {
      // JSON responses are automatically parsed.
      this.legal = response.data
    })
    .catch(e => {
      this.errors.push(e)
    })

    switch( this.$route.params.segment ) {
      case 'he':
      case 'k-12':
      case 'k12':
      case 'corp':
      case 'curriculum':
      case 'adventure':
      case 'digital-resources':
        break;
      case 'all':
      default:
        this.$route.params.segment = 'default';
        break;
    }
  },
  mounted() {
    setTimeout(function() { // Helps to hide the changes during the test
      document.body.style.visibility='visible';
    }, 200);
  },
  computed: {
    jsondata: function () {
      return atob(this.formdata)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/thank-you.vue